import * as THREE from 'three';
import { BACKGROUND_COLOR, FOG_COLOR, FOG_NEAR, FOG_FAR } from './config.js';

export const scene = new THREE.Scene();
scene.background = new THREE.Color(BACKGROUND_COLOR);
// Light atmospheric haze on the planet surface. Space objects opt out via
// `fog: false` on their materials so the sky and distant planets stay crisp.
scene.fog = new THREE.Fog(FOG_COLOR, FOG_NEAR, FOG_FAR);

export const camera = new THREE.PerspectiveCamera(
  62,
  innerWidth / innerHeight,
  0.1,
  1000,
);

export const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
renderer.setSize(innerWidth, innerHeight);
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.outputColorSpace = THREE.SRGBColorSpace;
document.body.appendChild(renderer.domElement);

addEventListener('resize', () => {
  camera.aspect = innerWidth / innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(innerWidth, innerHeight);
});

// ---------- Lighting ----------
// Warm directional sun that casts shadows across the planet surface.
const sun = new THREE.DirectionalLight(0xfff2d8, 2.1);
sun.position.set(40, 30, 20);
sun.castShadow = true;
sun.shadow.mapSize.set(2048, 2048);
{
  const d = 50;
  sun.shadow.camera.left = -d;
  sun.shadow.camera.right = d;
  sun.shadow.camera.top = d;
  sun.shadow.camera.bottom = -d;
  sun.shadow.camera.near = 1;
  sun.shadow.camera.far = 260;
  sun.shadow.bias = -0.0005;
}
scene.add(sun);

// Cool ambient + sky/ground hemi so shadowed sides don't plunge to black.
scene.add(new THREE.AmbientLight(0x405a80, 0.55));
scene.add(new THREE.HemisphereLight(0xaaccff, 0x2a3820, 0.45));
